var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c("div", [
              _vm._v("\n            欄位底色： 達 \n            "),
              _c("span", { style: { "background-color": "#FFFF00" } }, [
                _vm._v("大雨")
              ]),
              _vm._v("/ \n            "),
              _c("span", { style: { "background-color": "#FFC000" } }, [
                _vm._v("豪雨")
              ]),
              _vm._v("/ \n            "),
              _c("span", { style: { "background-color": "#FF0000" } }, [
                _vm._v("大豪雨")
              ]),
              _vm._v("/ \n            "),
              _c("span", { style: { "background-color": "#FF0000" } }, [
                _vm._v("超大豪雨")
              ]),
              _vm._v(" \n            標準\n        ")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "filter_condition_options",
        fn: function() {
          return [
            _c("MonitorOptionSet", {
              ref: "monitor_option_set",
              attrs: { option_set: _vm.option_set },
              on: { filter_data: _vm.filter_data }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                search: slot_props.search,
                should_draw_diagram_header: _vm.should_draw_diagram_header,
                enable_diagram_slot: true,
                enable_table_label: true,
                table_label_function: _vm.calc_accumulated_precp_level,
                show_download_doc_btn: true,
                is_show_chart_dialog_parent: _vm.is_show_chart_dialog
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time,
                "open-chart": _vm.assign_chart_component,
                "update:is_show_chart_dialog_parent": function($event) {
                  _vm.is_show_chart_dialog = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "diagram_dialog",
                    fn: function(ref) {
                      var close_dialog = ref.close_dialog
                      return [
                        _vm.is_show_chart_dialog
                          ? _c("GisChart", {
                              attrs: {
                                id: "belongs_monitor_chart",
                                chart_options: _vm.chart_options,
                                default_variable: _vm.$t("__rainfall.rainfall"),
                                prop_rain_selected: _vm.current_table_header
                              },
                              on: { "close-chart-dialog": close_dialog }
                            })
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(
                            '\n                    說明："--"標示，顯示該欄位無資料。 \n                '
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }